<template>
    <div v-if="loaded" class="toggle-content" :class="[className]" :aria-expanded="String(active)">
        <div class="toggle-content__trigger" :class="{ 'toggle-content__trigger--active' : active}">
            <button class="toggle-content__button" v-on:click="onClick" :aria-controls="getId()">
                <span class="toggle-content__button-label">
                    {{  label }}
                </span>
                <span class="toggle-content__button-icon">
                    <Icon :name="buttonIcon" />
                </span>
            </button>
        </div>
        <div :id="getId()" class="toggle-content__fold" :class="{ 'toggle-content__fold--toggled' : active}" :aria-hidden="!active">
            <div class="toggle-content__fold-inner wysiwyg">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  name: 'ToggleContent',
  data() {
    return {
      active: false,
      loaded: false,
      buttonIcon: 'chevron',
      className: `toggle-content--${this.name}`
    };
  },
  props: ['label', 'id', 'name', 'icon', 'toggled'],
  mounted() {
    this.loaded = true;

    if (this.toggled) {
      this.active = true;
    }

    if (this.icon) {
      this.buttonIcon = this.icon;
    }
  },
  methods: {
    onClick(e) {
      if (this.active) {
        this.active = false;
      } else {
        this.$parent.$children.forEach(child => {
          if (child !== this && typeof child.active !== 'undefined') {
            child.active = false;
          }
        });
        this.active = true;
      }
    },
    getId(id) {
      return `content-${this.name}-panel-${this.id}`;
    }
  },
  components: {
    Icon: Icon
  }
};
</script>